<template>
  <div class="agreement">
    <Checkbox
      class="checkbox"
      v-model:checked="localChecked"
      @update:checked="onUpdateChecked"
      :text-color="'t6'"
      :text-variant="'12'"
    >
      {{ $t('wo-yi-yue-du-bing-tong-yi') }}<CreditCoin />、<Purchase /><template
        v-if="buyType === BUY_TYPE.SUBSCRIBE"
      >
        、<Subscription />
      </template>
    </Checkbox>
  </div>
</template>

<script setup lang="ts" name="PayAgreement">
import { CreditCoin, Purchase, Subscription } from '@rendora/common/features/protocols';
import { BUY_TYPE } from '@rendora/common/types/enums';
import { Checkbox } from '@rendora/design/components/checkbox/index';
import { ref, watch } from 'vue';

const props = defineProps<{ checked: boolean; buyType: BUY_TYPE }>();

const emit = defineEmits<{
  (e: 'checked', value: boolean): void;
}>();

const localChecked = ref<boolean>(props.checked);

watch(
  () => props.checked,
  value => {
    localChecked.value = value;
  },
);

function onUpdateChecked(value: boolean) {
  emit('checked', value);
}
</script>

<style lang="scss" scoped>
.agreement {
  font-size: 12px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  margin-top: 44px;
  gap: 4px;
}

.checkbox {
  margin-top: 6px;
}
</style>
